import { render, staticRenderFns } from "./NonStandardConstruction.vue?vue&type=template&id=45aff348"
import script from "./NonStandardConstruction.vue?vue&type=script&lang=js"
export * from "./NonStandardConstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports